import SiteKeyboardsContainer from 'components/SiteKeyboards/SiteKeyboardsContainer'
import SiteKeyboardsData from 'components/SiteKeyboards/SiteKeyboardsData'
import SiteKeyboardsPresentation from 'components/SiteKeyboards/SiteKeyboardsPresentation'

export default {
  Container: SiteKeyboardsContainer,
  Data: SiteKeyboardsData,
  Presentation: SiteKeyboardsPresentation,
}
